
import AddToCart from '../AddToCart';
import BookCarousel from '../BookCarousel';


export default function BookPage() {

  document.title = `Love Never Dies by Eka Kurniawan | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `In Love Never Dies, Eka Kurniawan satirizes the ravenous surges of unrequited obsession as they haunt the life of an elderly man, a comic tale of longing in extremity that asks: when love fails to expire with age, death, or circumstance, what might it become?`);


  return (<div className='newPageContainer'>
    <div className='productContainer'>
      <div className='productImage_container  '>
        <div className='productCarousel'>
          <BookCarousel images={['../../Series-Three/EkaKurniawan_10_Mockup1.png', '../../Series-Three/EkaKurniawan_10_Mockup2.png', '../../Series-Three/EkaKurniawan_10_Mockup3.webp']} start={1} />
        </div>
      </div>
      <div className='productInfo_container'>
        <div className='productInfo_inner'>
          <div className='productInfo'>
            <h1 className='productTitle'>Love Never Dies</h1>
            <div className='productAuthor'>Eka Kurniawan</div>
            <div className='productTranslator'>Translated by Annie Tucker</div>
          </div>
          <div className='productBuyControls'>
            <AddToCart context={'product'} id={'9798990416543'} />
            <div className='productPrice'>$14.99 USD</div>
          </div>


          <div className='productDescription'>In <em>Love Never Dies</em>, Eka Kurniawan satirizes the ravenous surges of unrequited obsession as they haunt the life of an elderly man, a comic tale of longing in extremity that asks: when love fails to expire with age, death, or circumstance, what might it become?
          </div>
          <div className='productDescription'>
            <p>
              One of the most important writers to emerge from southeast Asia in recent decades, <strong>Eka Kurniawan</strong> is the author of novels, short stories, essays and screenplays that cathect the historical and the fantastic. His published books, including the acclaimed <em>Beauty is a Wound</em> (trans. by Annie Tucker, 2015), have been translated from Bahasa into thirty-five languages. In Kurniawan’s work, the deep roots of the affective draw close and disturb, to shake normative lineages of political identification and human belonging.
            </p>
            <p>
              <strong>Annie Tucker</strong> is a writer and translator living in Los Angeles. Tucker is best known for bringing key voices in Indonesian literature to English-language audiences and specifically, for her work with Kurniawan, which has been recognized by PEN USA, The American Literary Translator’s Association, The Association for Asian Studies, US-INDO and Fulbright-Hays, among others. She holds a PhD from UCLA.
            </p>
            <p><em>Back cover photo: Fransisca Angela
            </em></p>
          </div>
          <div className='productMetadata'>
            <div>Series III, No. 10</div>
            <div>Summer 2025</div>
            <div>ISBN 979–8–990416–54–3</div>
            <div>4.125 x 2.75 inches</div>
            <div>152 Pages</div>
          </div>
        </div>
      </div>
    </div>
  </div>)
}